import getConfig from 'next/config'

import { linkBuilder } from '@/components/Link/linkBuilder'
import { CanonicalFilter } from '@/types/filter'

export const getAlternatePageLinksForListingDetail = (lang: Locale, listingId: string) => {
  const { publicRuntimeConfig } = getConfig()

  switch (lang) {
    case 'fr':
      return (
        <>
          <link
            href={`${publicRuntimeConfig.lisaWebsite}${linkBuilder.listingDetail.url(lang, listingId)}`}
            hrefLang={`${lang}`}
            rel="alternate"
          />
          <link
            href={`${publicRuntimeConfig.lisaWebsite}${linkBuilder.listingDetail.url(lang, listingId)}`}
            hrefLang="x-default"
            rel="alternate"
          />
        </>
      )
    default:
      return (
        <>
          <link
            href={`${publicRuntimeConfig.lisaWebsite}${linkBuilder.listingDetail.url('en', listingId)}`}
            hrefLang="en"
            rel="alternate"
          />
          <link
            href={`${publicRuntimeConfig.lisaWebsite}${linkBuilder.listingDetail.url('it', listingId)}`}
            hrefLang="it"
            rel="alternate"
          />
          <link
            href={`${publicRuntimeConfig.lisaWebsite}${linkBuilder.listingDetail.url('it', listingId)}`}
            hrefLang="x-default"
            rel="alternate"
          />
        </>
      )
  }
}

export const getAlternatePageLinksWithZone = (lang: Locale, segment: string) => {
  const { publicRuntimeConfig } = getConfig()

  switch (lang) {
    case 'fr':
      return (
        <>
          <link href={`${publicRuntimeConfig.lisaWebsite}/fr/acheter-bien/${segment}/`} hrefLang="fr" rel="alternate" />
          <link
            href={`${publicRuntimeConfig.lisaWebsite}/fr/acheter-bien/${segment}/`}
            hrefLang="x-default"
            rel="alternate"
          />
        </>
      )
    default:
      return (
        <>
          <link href={`${publicRuntimeConfig.lisaWebsite}/houses-for-sale/${segment}/`} hrefLang="en" rel="alternate" />
          <link
            href={`${publicRuntimeConfig.lisaWebsite}/it/case-in-vendita/${segment}/`}
            hrefLang="it"
            rel="alternate"
          />
          <link
            href={`${publicRuntimeConfig.lisaWebsite}/it/case-in-vendita/${segment}/`}
            hrefLang="x-default"
            rel="alternate"
          />
        </>
      )
  }
}

export const getAlternatePageLinksWithCanonicalFilter = (
  lang: Locale,
  citySegment: string,
  canonicalFilter: CanonicalFilter
) => {
  const { publicRuntimeConfig } = getConfig()

  switch (lang) {
    case 'fr':
      return (
        <>
          <link
            href={`${publicRuntimeConfig.lisaWebsite}/fr/acheter-bien/${citySegment}/${canonicalFilter.slug.fr}/`}
            hrefLang="fr"
            rel="alternate"
          />
          <link
            href={`${publicRuntimeConfig.lisaWebsite}/fr/acheter-bien/${citySegment}/${canonicalFilter.slug.fr}/`}
            hrefLang="x-default"
            rel="alternate"
          />
        </>
      )
    default:
      return (
        <>
          <link
            href={`${publicRuntimeConfig.lisaWebsite}/houses-for-sale/${citySegment}/${canonicalFilter.slug.en}/`}
            hrefLang="en"
            rel="alternate"
          />
          <link
            href={`${publicRuntimeConfig.lisaWebsite}/it/case-in-vendita/${citySegment}/${canonicalFilter.slug.it}/`}
            hrefLang="it"
            rel="alternate"
          />
          <link
            href={`${publicRuntimeConfig.lisaWebsite}/it/case-in-vendita/${citySegment}/${canonicalFilter.slug.it}/`}
            hrefLang="x-default"
            rel="alternate"
          />
        </>
      )
  }
}
